import { render, staticRenderFns } from "./caseSupervision.vue?vue&type=template&id=49a0709e&"
import script from "./caseSupervision.vue?vue&type=script&lang=js&"
export * from "./caseSupervision.vue?vue&type=script&lang=js&"
import style0 from "./caseSupervision.vue?vue&type=style&index=0&id=49a0709e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports